import { render, staticRenderFns } from "./BlockHeader.vue?vue&type=template&id=0a085022&"
import script from "./BlockHeader.vue?vue&type=script&lang=js&"
export * from "./BlockHeader.vue?vue&type=script&lang=js&"
import style0 from "./BlockHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports